import { useEffect, useState } from "react";
import moment from "moment";
// material
import { Card, Table, Stack, TableRow, TableBody, TableCell, Container, Typography, TableContainer, Select, TextField, FormControl, InputLabel, MenuItem, Grid, CircularProgress } from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchNotFound from "../../components/SearchNotFound";

import ListHead from "src/components/common/ListHead";
import ListToolbar from "src/components/common/ListToolbar";
import { alert } from "src/services/alert";
import MyPagination from "src/components/common/MyPagination";
import { asyncRequest } from "src/services/network";
import MyDateRangePicker from "src/components/common/my-date-range-picker/MyDateRangePicker";

const TYPE_MAP = { 1: "增加", 2: "减少", 3: "冻结增加", 20: "推荐业绩转换" };
const types = [1, 2, 3, 20];

const TABLE_HEAD = [
  { id: "id", label: "ID", alignRight: false },
  { id: "user_id", label: "用户ID", alignRight: false },
  { id: "type", label: "类型", alignRight: false },
  { id: "amount", label: "变动数量", alignRight: false },
  { id: "before_balance", label: "变动前余额", alignRight: false },
  { id: "after_balance", label: "变动后余额", alignRight: false },
  { id: "remark", label: "备注", alignRight: false },
  { id: "create_time", label: "创建时间", alignRight: false },
];

export default function EquityValueRecord() {
  const [items, setItems] = useState(null);
  const [total, setTotal] = useState(0);

  const [filter, setFilter] = useState({
    page: 0,
    size: 10,
    uid: "",
    type: -1,
    createdAt: null,
  });

  useEffect(() => {
    setItems(null);
    setTotal(0);
    getItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  async function getItems() {
    const { data, count } = await asyncRequest({
      path: "/finance/equity-value/list",
      data: filter,
    });

    setItems(data);
    setTotal(count);
  }

  const handlePageChange = (event, value, newSize) => {
    if (newSize !== undefined) {
      setFilter({ ...filter, page: 0, size: newSize });
      return;
    }
    const newPage = value - 1;
    if (newPage === filter.page) return;
    setFilter({
      ...filter,
      page: newPage,
    });
  };

  function handleFilterChange(ki, val) {
    setFilter({
      ...filter,
      [ki]: val,
    });
  }

  function handleReset() {
    setFilter({
      page: 0,
      size: 10,
      uid: "",
      type: -1,
      createdAt: null,
    });
  }

  async function handleExport() {
    const { msg } = await asyncRequest({
      path: "/finance/equity-value/export",
      data: filter,
    });

    alert(msg, "success");
  }

  const isUserNotFound = items && items.length === 0;

  return (
    <Page title="权益值明细">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            权益值明细
          </Typography>
        </Stack>

        <Card>
          <ListToolbar showSearch={false} filterName={filter.search} onReset={handleReset} onRefresh={getItems} onExport={handleExport}>
            <Grid container rowGap={2}>
              <Grid item lg={6} sm={6} md={3}>
                <MyDateRangePicker
                  value={filter.createdAt}
                  onChange={(val) => {
                    setFilter({
                      ...filter,
                      createdAt: val,
                    });
                  }}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <TextField
                  size="small"
                  style={{ width: 200 }}
                  label="用户ID"
                  placeholder="用户ID"
                  autoComplete="off"
                  id="uid"
                  value={filter.uid}
                  onChange={(e) => {
                    handleFilterChange("uid", e.target.value);
                  }}
                />
              </Grid>
              <Grid item sm={6} md={3}>
                <FormControl size="small">
                  <InputLabel>类型</InputLabel>
                  <Select
                    label="类型"
                    value={filter.type}
                    onChange={(e) => {
                      setFilter({
                        ...filter,
                        type: e.target.value,
                      });
                    }}
                    style={{ width: 250 }}
                  >
                    <MenuItem value={-1}>全部</MenuItem>
                    {types.map((type) => (
                      <MenuItem key={type} value={type}>
                        {TYPE_MAP[type]}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </ListToolbar>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} />
                {!items ? (
                  <Stack sx={{ width: 500, height: 200 }} alignItems="center" justifyContent="center">
                    <CircularProgress />
                  </Stack>
                ) : (
                  <TableBody>
                    {items.map((row) => {
                      const { id, user_id, type, amount, before_balance, after_balance, remark, create_time } = row;

                      return (
                        <TableRow hover key={id} tabIndex={-1}>
                          <TableCell align="left">{id}</TableCell>
                          <TableCell align="left">{user_id}</TableCell>
                          <TableCell align="left">{TYPE_MAP[type] || type}</TableCell>
                          <TableCell align="left">{amount}</TableCell>
                          <TableCell align="left">{before_balance}</TableCell>
                          <TableCell align="left">{after_balance}</TableCell>
                          <TableCell align="left">{remark}</TableCell>
                          <TableCell align="left">{moment(create_time).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                )}

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={8} sx={{ py: 5 }}>
                        <SearchNotFound searchQuery={filter.uid} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <MyPagination total={total} page={filter.page} size={filter.size} onChange={handlePageChange} />
        </Card>
      </Container>
    </Page>
  );
}
